const CartItem = require('./cart_item.js');

class Cart {
  constructor(json) {
    this.json = json;

    this.count = json.count;
    this.cartItems = this.buildCartItems();
    this.paymentMethodGroups = json.payment_method_groups;
  }

  buildCartItems() {
    return this.json.cart_items.map(item => new CartItem(item));
  }

  cartItemForProductId(productId) {
    return this.cartItems.find(cartItem => cartItem.productId === productId);
  }
}

module.exports = Cart;



// WEBPACK FOOTER //
// ./javascripts/components/cart/cart.js